import { Col, Row } from 'reactstrap';
import React from 'react';

const FormRow = ({ left, right }) => {
  return (
    <Row>
      <Col xs={4}>{left}</Col>
      <Col xs={4}>{right}</Col>
    </Row>
  );
};

export default FormRow;



// WEBPACK FOOTER //
// ./src/containers/FacilityHazarWasteReportContainer/FacilityHazarWasteReportForm/FormRow.js